import React, { Fragment } from 'react'
import { useSelector } from 'react-redux'
import styled from 'styled-components'
import _ from 'lodash'
import { Grid } from '@material-ui/core'
import { Dialog } from '@progress/kendo-react-dialogs'
import { Field, FieldWrapper, Form } from '@progress/kendo-react-form'
import { Input } from '@progress/kendo-react-inputs'
import { GridWrapper, Headline, InnerGrid, Placeholder, SafeCheckbox, StyledPaper } from '../styled/FormComponents'
import { Button } from '@progress/kendo-react-buttons'
import { getCurrentProject, getLanguages } from '../../store/selectors'
import { ComboBoxField, DropDownField } from '../index'
import { getMediaTypeOptions } from '../../services'

export default ({ onClose, onSubmit }) => {
    const project = useSelector(getCurrentProject)
    const newEditionData = {
        copyValues: false,
        edition: project.edition+1,
        ..._.pick(project, [
            'mediaNumber',
            'title',
            'projectLanguage',
            'mediaType',
            'customerDepartment',
            'customerName',
            'customerCostCenter',
            'customerWANumber'
        ])
    }
    const languages = useSelector(getLanguages)
    const mediaTypes = getMediaTypeOptions()
    const spaceBetweenGrids = 2

    return <Dialog title={`Neue Auflage: ${project.edition + 1}`} onClose={onClose} minWidth="500px">
        <GridWrapper>
            <Form initialValues={newEditionData} onSubmit={onSubmit} render={(formRenderProps) => (
                <Fragment>
                    <Placeholder height="10px"/>
                    <StyledPaper>
                        <Headline>Mediendaten</Headline>
                        <Grid container spacing={spaceBetweenGrids}>
                            <InnerGrid item md={6}>
                                <Field name="mediaNumber" component={Input} label="Mediennummer"/>
                            </InnerGrid>
                            <InnerGrid item md={6}>
                                <Field name="title" component={Input} label="Projektbezeichnung"/>
                            </InnerGrid>
                        </Grid>
                        <Placeholder/>
                        <Grid container spacing={spaceBetweenGrids}>
                            <InnerGrid item md={6}>
                                <Field name="projectLanguage" component={DropDownField} label="Sprache"
                                       data={languages}/>
                            </InnerGrid>
                            <InnerGrid item md={6}>
                                <Field name="mediaType" component={ComboBoxField} label="Werbemittel"
                                       data={mediaTypes} allowCustom suggest filterable/>
                            </InnerGrid>
                        </Grid>
                    </StyledPaper>
                    <StyledPaper>
                        <Headline>Auftraggeber</Headline>
                        <Grid container spacing={spaceBetweenGrids}>
                            <InnerGrid item md={6}>
                                <Field name="customerDepartment" component={Input} label="Abteilung"/>
                            </InnerGrid>
                            <InnerGrid item md={6}>
                                <Field name="customerName" component={Input} label="Ansprechpartner" type="text"/>
                            </InnerGrid>
                        </Grid><Grid container spacing={spaceBetweenGrids}>
                        <InnerGrid item md={6}>
                            <Field name="customerCostCenter" component={Input} label="Kostenstelle"/>
                        </InnerGrid>
                        <InnerGrid item md={6}>
                            <Field name="customerWANumber" component={Input} label="WA-Nummer"/>
                        </InnerGrid>
                    </Grid>
                    </StyledPaper>
                    <StyledPaper>
                        <FieldWrapper>
                            <Field name="copyValues" component={SafeCheckbox} label="Restliche Daten übernehmen"/>
                            <Field name="dummyField" component={Invisible}/>
                        </FieldWrapper>
                    </StyledPaper>
                    <StyledButton primary onClick={() => {
                        formRenderProps.onChange('dummyField', {value: ''})
                        formRenderProps.onSubmit()
                    }}>Anlegen</StyledButton>
                    <StyledButton onClick={onClose}>Abbrechen</StyledButton>
                </Fragment>
            )}/>
        </GridWrapper>
    </Dialog>
}

const StyledButton = styled(Button)`
    margin-right: 15px;
`
const Invisible = styled.div`
    display: none;
`



// WEBPACK FOOTER //
// ./src/components/dialog/NewEditionDialog.js